import { Editor, Transforms } from 'slate';
import Tool, { type ToolArgs } from '../../tools/Tool';
import TableUtils from './TableUtils';
import EditorUtils from '../../AhaEditorUtils/EditorUtils';
import { isTableCellElement } from '../../types/guards';

// Clear the content of a table, leaving the structure
// untouched but all of the cells empty.
class ToolTableClearContent extends Tool {
  static toolName = 'Clear content';
  static iconClass = 'fa-regular fa-broom-wide';

  static action({ editor, element }: ToolArgs): void {
    if (!editor) return;

    const tableEntry = TableUtils.currentTable(editor);
    if (!tableEntry) return;

    const [, tablePath] = tableEntry;
    const cellNodes = Array.from(
      Editor.nodes(editor, {
        at: tablePath,
        match: isTableCellElement,
      })
    );

    for (const [node, path] of cellNodes) {
      Editor.withoutNormalizing(editor, () => {
        for (let i = node.children.length - 1; i >= 0; i--) {
          Transforms.removeNodes(editor, {
            at: [...path, i],
          });
        }

        Transforms.insertNodes(editor, EditorUtils.emptyParagraph(), {
          at: [...path, 0],
        });
      });
    }
  }
}

export default ToolTableClearContent;
